import React, {Component} from 'react';
import {Modal, Button, Row, Col}  from 'react-bootstrap'
import SecondServer from '../../database/SecondServer'
import {urlGetSite} from '../../database/apiUrls'
import Checkbox from '../../Edit/Checkbox'
import { NumberPicker } from './NumberPicker';
import { parseBoolean } from '../../Utils/miscRefactors';
import '../report-header.css'
import '../Controls/massedit.css'
import '../../commoninputs.css'
import './DcapDownModal.css'

import { siteAccessCode } from '../../database/apiv2SiteAccessor';

export default class DcapDownModal extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      rerender: 0,
      arrCheckboxes: [false, false, false],
      custom: 0,
      errMsg: "",
    }
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    const deref = this.props?.siteInfo
    const paramChecks = [this.parseApi(deref?.dcap_down_one_day),
      this.parseApi(deref?.dcap_down_two_day),
      this.parseApi(deref?.dcap_down_two_weeks)]
    this.setState ({arrCheckboxes: paramChecks, custom:this.props?.siteInfo?.dcap_down_custom}) 
  }
  componentDidUpdate(prevProps) {
    if (!prevProps?.siteInfo && this.props.siteInfo) {
      this.componentDidMount()
    }
  }
  parseApi (apiVal) {
    return apiVal !== undefined ? parseBoolean(apiVal) : true
  }
  async handleClose() {
    this.props.hide();
  }

  handleChange = event => {
    this.setState ({rerender: this.state.rerender+1})
  }
  
  async handleSave() {
    const apiData = {dcap_down_one_day: this.state.arrCheckboxes[0],
      dcap_down_two_day: this.state.arrCheckboxes[1],
      dcap_down_two_weeks: this.state.arrCheckboxes[2], dcap_down_custom: this.state.custom}
    const ss = new SecondServer(this.props);
    const url = urlGetSite(siteAccessCode(this.props.getActiveSite()))
    const resp = await ss.apiSaveData(url, {...apiData})
    const retcode = resp?.data?.data?.result?.message ?? ss.getErrorMsg()
    if (retcode === "OK" || !retcode) {
      this.props.hide()
      if (this.props?.onChange) 
        this.props.onChange(apiData)
    }
    else
      this.setState({errMsg:retcode})
  }
 
  footerText () {
    return (
      this.state.errMsg ?
        <div className="modal-error">{this.state.errMsg}</div> :
        <div className="footer-text">Settings apply to all DCAP down recipients</div>
    )    
  }
  onCheck = (state, index) => {
    let temp = this.state.arrCheckboxes;
    temp[index] = state;
    this.setState({arrCheckboxes : temp })
  }
  custom = (days) => {
    this.setState({custom: days})
  }
  checkRow (props) {
    return (<span>
      <Checkbox parentData={this.onCheck} label="1 Day" selected={this.state.arrCheckboxes[0]}
        {...props} index='0' id="oneday"/>
      <span className='box-spacer'></span>
      <Checkbox parentData={this.onCheck} label="2 Days" selected={this.state.arrCheckboxes[1]}
        {...props} index='1' id="twoday"/>
      <span className='box-spacer'></span>
      <Checkbox parentData={this.onCheck} label="14 Days" selected={this.state.arrCheckboxes[2]}
        {...props} index='2' id="fortnight" />
    </span>)
  }
  render() {
    return(
    <Modal show={this.props.show} onHide={this.handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>DCAP Down Notifications</Modal.Title>
      </Modal.Header>
      <Modal.Body className='body-indent'>
        Receive Alerts when DCAP goes out of contact for:
        <Row className='mt-5 modal-top-row '>
          <Col className="col-4 mt-2">{this.checkRow(this.props)}</Col>
          <Col className="col-2">
            <NumberPicker value={this.state.custom} onUpdate={this.custom}/></Col>
          <Col className='mt-2'>Custom Days</Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        {this.footerText()}
        <Button className="custom-std-btn" onClick={()=>this.handleClose()}>Cancel</Button>
        <Button className="custom-std-btn" onClick={()=>this.handleSave()}>Save</Button>
      </Modal.Footer>
    </Modal>
    )
  }
}
